import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import {
  FormGroup,
  ControlLabel,
} from 'react-bootstrap';

import SupervisorInput from '../../fields/SupervisorInput';
import AllUsersMonthBonusList from './AllUsersMonthBonusList';
import BonusPeriodEnhanced from './BonusPeriodEnhanced';

import { queryGetAllBonusMonthsGQL } from '../../bonuses/graphql/allBonusMonthApi';
import { getSupervisorId, getBonusMonth } from '../selectors';
import { getCorpAdminFeature, getUser } from '../../authentication/selectors';
import { setDefaultSupervisorId, setBonusMonth, setSupervisorId } from '../actions';

/* eslint-disable react/no-unused-prop-types */
const propTypes = exact({
  currentlyLoggedInUser: PropTypes.object.isRequired,
  supervisorId: PropTypes.number,
  setSupervisorIdClearUserIdAction: PropTypes.func.isRequired,

  bonusMonth: PropTypes.string,
  setDefaultSupervisorIdAction: PropTypes.func.isRequired,

  allBonusMonths: PropTypes.array.isRequired,
  setBonusMonthAction: PropTypes.func.isRequired,
  isCorpAdmin: PropTypes.bool.isRequired,
});
/* eslint-enabled react/no-unused-prop-types */

const FilterAllUsersMonthBonusPanel = (props) => {
  const {
    currentlyLoggedInUser,
    supervisorId,
    setSupervisorIdClearUserIdAction,
    isCorpAdmin,
  } = props;

  const { allBonusMonths } = props;


  return (
    <div>
      <FormGroup>
        <ControlLabel className="control-label">
          Supervisor:
        </ControlLabel>
        <SupervisorInput
          currentUser={currentlyLoggedInUser}
          selectedSupervisorId={supervisorId}
          onSelectSupervisor={(e) => { return setSupervisorIdClearUserIdAction(e); }}
          showAllSupervisors={isCorpAdmin}
        />
      </FormGroup>
      <FormGroup>
        <ControlLabel className="control-label">
          Bonus Period:
        </ControlLabel>
        <BonusPeriodEnhanced allBonusMonths={allBonusMonths} />
      </FormGroup>
      <AllUsersMonthBonusList />
    </div>
  );
};


FilterAllUsersMonthBonusPanel.propTypes = propTypes;

const mapStateToProps = (state) => {
  return {
    bonusMonth: getBonusMonth(state),
    supervisorId: getSupervisorId(state),
    currentlyLoggedInUser: getUser(state),
    isCorpAdmin: getCorpAdminFeature(state),
  };
};
const mapDispatchToProps = {
  setDefaultSupervisorIdAction: setDefaultSupervisorId,
  setBonusMonthAction: setBonusMonth,
  setSupervisorIdClearUserIdAction: setSupervisorId,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);


const withInitPage = lifecycle({
  componentWillMount() {
    const { supervisorId } = this.props;
    if (supervisorId === 0) {
      this.props.setDefaultSupervisorIdAction();
    }

    const {
      allBonusMonths, setBonusMonthAction, bonusMonth,
    } = this.props;

    if (!bonusMonth) {
      const latestMonthBonus = allBonusMonths[0].iso8601;
      setBonusMonthAction(latestMonthBonus);
    }
  },
});

const enhance = compose(
  withRedux,
  queryGetAllBonusMonthsGQL,
  withInitPage,
);


export default enhance(FilterAllUsersMonthBonusPanel);
